import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 36, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function SectionTag({ children, center = false }) {
  return (
    <Reveal className={`flex items-center gap-4 mb-6 ${center ? "justify-center" : ""}`}>
      <span className="h-px w-10 bg-gradient-to-r from-transparent to-[#D4AF37]" />
      <span className="text-[11px] uppercase tracking-[0.35em] text-[#D4AF37] font-semibold">{children}</span>
      <span className="h-px w-10 bg-gradient-to-l from-transparent to-[#D4AF37]" />
    </Reveal>
  );
}

export function SectionTitle({ children, className = "" }) {
  return (
    <Reveal delay={0.08}>
      <h2 className={`font-serif-lux text-3xl sm:text-4xl lg:text-5xl leading-[1.08] text-[#F5F5F0] ${className}`}>
        {children}
      </h2>
    </Reveal>
  );
}

const STATUS_STYLES = {
  Operational: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  "Under Development": "bg-[#D4AF37]/10 text-[#F3E5AB] border-[#D4AF37]/40",
  Announced: "bg-blue-500/10 text-blue-400 border-blue-500/30",
  Allotted: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  Proposed: "bg-purple-500/10 text-purple-400 border-purple-500/30",
};

export function StatusBadge({ status, className = "" }) {
  return (
    <span
      data-testid={`status-badge-${(status || "").toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 text-[10px] uppercase tracking-[0.2em] border rounded-full ${STATUS_STYLES[status] || STATUS_STYLES.Proposed} ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current" />
      {status}
    </span>
  );
}

export function GoldButton({ children, variant = "solid", className = "", ...props }) {
  const base =
    "inline-flex items-center justify-center gap-2 px-7 py-3.5 text-[12px] font-semibold uppercase tracking-[0.22em] transition-colors duration-300 rounded-[2px]";
  const styles =
    variant === "solid"
      ? "bg-gradient-to-r from-[#C5A059] to-[#D4AF37] text-black hover:from-[#D4AF37] hover:to-[#F3E5AB]"
      : variant === "ghost"
      ? "text-[#A1A1AA] hover:text-[#F3E5AB] underline-offset-8 hover:underline"
      : "border border-[#D4AF37]/50 text-[#F3E5AB] hover:bg-[#D4AF37]/10 hover:border-[#D4AF37]";
  return (
    <button className={`${base} ${styles} ${className}`} {...props}>
      {children}
    </button>
  );
}

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) {
    if (window.location.pathname !== "/") window.location.href = `/#${id}`;
    return;
  }
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -70, duration: 1.6 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
}
